<div class="progress-bar-container">
  <span class="progress-bar-new d-flex">
    @if (!success) {
      <svg
        width="328"
        height="12"
        viewBox="0 0 328 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="160" y="4" width="158" height="4" fill="#E5E7EB" />
        <rect x="160" y="4" width="158" height="4" fill="#C4C4C4" />
        <rect y="4" width="160" height="4" fill="#E5E7EB" />
        <rect y="4" width="160" height="4" fill="#31C48D" />
        <path
          d="M322 0.1875C318.79 0.1875 316.188 2.78984 316.188 6C316.188 9.21016 318.79 11.8125 322 11.8125C325.21 11.8125 327.812 9.21016 327.812 6C327.812 2.78984 325.21 0.1875 322 0.1875ZM323.875 6C323.875 7.03387 323.034 7.875 322 7.875C320.966 7.875 320.125 7.03387 320.125 6C320.125 4.96613 320.966 4.125 322 4.125C323.034 4.125 323.875 4.96613 323.875 6Z"
          fill="#C4C4C4"
        />
      </svg>
    }
    @if (success) {
      <svg
        width="328"
        height="12"
        viewBox="0 0 328 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="160" y="4" width="158" height="4" fill="#E5E7EB" />
        <rect x="160" y="4" width="158" height="4" fill="#31C48D" />
        <rect y="4" width="160" height="4" fill="#E5E7EB" />
        <rect y="4" width="160" height="4" fill="#31C48D" />
        <path
          d="M322 0.1875C318.79 0.1875 316.188 2.78984 316.188 6C316.188 9.21016 318.79 11.8125 322 11.8125C325.21 11.8125 327.812 9.21016 327.812 6C327.812 2.78984 325.21 0.1875 322 0.1875ZM323.875 6C323.875 7.03387 323.034 7.875 322 7.875C320.966 7.875 320.125 7.03387 320.125 6C320.125 4.96613 320.966 4.125 322 4.125C323.034 4.125 323.875 4.96613 323.875 6Z"
          fill="#31C48D"
        />
      </svg>
    }
  </span>
  <div class="label-section d-flex align-items-center justify-content-between">
    <div class="lhs">
      <span
        ><svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71978 15.75 0.25 12.2802 0.25 8C0.25 3.71978 3.71978 0.25 8 0.25C12.2802 0.25 15.75 3.71978 15.75 8ZM7.10356 12.1036L12.8536 6.35356C13.0488 6.15831 13.0488 5.84172 12.8536 5.64647L12.1465 4.93937C11.9512 4.74409 11.6346 4.74409 11.4393 4.93937L6.75 9.62869L4.56066 7.43934C4.36541 7.24409 4.04881 7.24409 3.85353 7.43934L3.14644 8.14644C2.95119 8.34169 2.95119 8.65828 3.14644 8.85353L6.39644 12.1035C6.59172 12.2988 6.90828 12.2988 7.10356 12.1036V12.1036Z"
            fill="#31C48D"
          />
        </svg>
      </span>
      <span class="label">{{ steps[0] }}</span>
    </div>
    <div class="rhs">
      <span>
        @if (!success) {
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 0.25C3.71978 0.25 0.25 3.71978 0.25 8C0.25 12.2802 3.71978 15.75 8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71978 12.2802 0.25 8 0.25ZM10.5 8C10.5 9.3785 9.3785 10.5 8 10.5C6.6215 10.5 5.5 9.3785 5.5 8C5.5 6.6215 6.6215 5.5 8 5.5C9.3785 5.5 10.5 6.6215 10.5 8Z"
              [class.disable]="disableCompanyVerification"
              [class.wallet-blue]="isCargoWallet"
              class="enable"
            />
          </svg>
        }
        @if (success) {
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71978 15.75 0.25 12.2802 0.25 8C0.25 3.71978 3.71978 0.25 8 0.25C12.2802 0.25 15.75 3.71978 15.75 8ZM7.10356 12.1036L12.8536 6.35356C13.0488 6.15831 13.0488 5.84172 12.8536 5.64647L12.1465 4.93937C11.9512 4.74409 11.6346 4.74409 11.4393 4.93937L6.75 9.62869L4.56066 7.43934C4.36541 7.24409 4.04881 7.24409 3.85353 7.43934L3.14644 8.14644C2.95119 8.34169 2.95119 8.65828 3.14644 8.85353L6.39644 12.1035C6.59172 12.2988 6.90828 12.2988 7.10356 12.1036V12.1036Z"
              fill="#31C48D"
            />
          </svg>
        }
      </span>
      <span
        class="label company-verification"
        [class.disable]="disableCompanyVerification"
        [class.success]="success"
        [class.wallet-blue]="isCargoWallet"
        >{{ steps[1] }}</span
      >
    </div>
  </div>
</div>
